import { Injectable } from '@angular/core';

import { HttpClient } from './../http-client';
import { Config } from '../local/config';
import { UserData } from '../local/user-data';

/*
  Generated class for the ClientProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ClientProvider {

  constructor(public http: HttpClient,
    public userData: UserData,
    public config: Config) {
    console.log('Hello UserProvider Provider');
  }

  all() {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/customers`;

    return this.http.get(link, 1);
  }

  getClientLocations() {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/alfa/reports`;
    let data = {spName: "ActiveLoansLocations", spParams: []};

    return this.http.post(link, data, 1)
    .then((res: any) => {
      console.log('Data Client Locations', res.data)
      if(res && res.data && res.data.table) {
        res.data = res.data.table;
      }
      return res;
    });
  }

  customersCurrentUser() {
    
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/customers/currentUser`;

    return this.http.get(link, 1);
  }

  getClientByID(id: any) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/customers/${id}`;

    return this.http.get(link, 1);
  }

  getFilesByClientID(id: any) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/files/customers/${id}`;

    return this.http.get(link, 1);
  }

  save(customer: any) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/customers`;

    return this.http.post(link, customer, 1);
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/client/client.ts